import type { IfPageSettingChange, IfPageSettingForm } from './types';
import { PageStore, AssignedProductStore } from './types';

/**
 * App State
 */
export class State {
  public page: PageStore;
  public article: PageStore;
  public index: PageStore;
  public product: PageStore;
  public collection: PageStore;

  //page setting
  public loadingPageSetting: boolean;
  public getPageSettingSuccess: boolean;
  public defaultPageSettingForm: IfPageSettingForm;
  public pageSettingForm: IfPageSettingForm;
  public pageSettingChange: IfPageSettingChange;
  public blogHandle: string;
  public pageSettingIsError: boolean;
  public updatedSettingPageList: Array<number>;
  public assignedProduct: AssignedProductStore;
  public loadingFrame: boolean;
  public loadingContentEditor: boolean;
  public loadingFrameMessage: string;
  public isProductNotFound: boolean;
  constructor() {
    this.page = new PageStore();
    this.article = new PageStore();
    this.index = new PageStore();
    this.product = new PageStore();
    this.collection = new PageStore();

    //page setting
    this.loadingPageSetting = false;
    this.loadingContentEditor = true;
    this.isProductNotFound = false;
    this.loadingFrame = true;
    this.loadingFrameMessage = '';
    this.getPageSettingSuccess = false;
    this.defaultPageSettingForm = this.getEmptyPageSettingForm();
    this.pageSettingForm = this.getEmptyPageSettingForm();
    this.blogHandle = '';
    this.pageSettingIsError = false;
    this.updatedSettingPageList = [];
    this.assignedProduct = new AssignedProductStore();
    this.resetPageSettingChange();
  }

  public getEmptyPageSettingForm(): IfPageSettingForm {
    return Object.assign(
      {},
      {
        general: {
          title: '',
          handle: '',
          description: '',
          featuredImage: '',
        },
        layout: {
          headerFooter: false,
        },
        advance: {
          lazyLoad: false,
        },
      },
    );
  }

  public resetAssignedProduct() {
    this.assignedProduct = {
      ...this.assignedProduct,
      list: [],
      cachedList: [],
      fetchedAll: false,
      listQuery: [],
      cachedListQuery: [],
      fetchedAllQuery: false,
      endCursor: '',
      endCursorQuery: '',
      popupAssignedProductActive: false,
      isAssignProductModal: true,
    };
  }

  public resetPageSettingChange() {
    this.pageSettingChange = {
      // general
      title: false,
      handle: false,
      description: false,
      featuredImage: false,
      // layout
      headerFooter: false,
      // advance
      lazyLoad: false,
    };
  }
}

const state = new State();

export default state;
